import { render } from "./IForm.vue?vue&type=template&id=32cfc82f"
import script from "./IForm.vue?vue&type=script&lang=js"
export * from "./IForm.vue?vue&type=script&lang=js"
script.render = render

export default script